import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Smartphone, MailCheck, Phone } from "lucide-react";
import { businessDetails } from "../data/content";
import { track } from "../lib/analytics";

const ext = { target: "_blank", rel: "noopener noreferrer" };

// Fixed customer-action bar for mobile: App / Postbox / Call.
export const MobileCustomerActionBar = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    // Reveal after the hero CTAs scroll out of easy reach.
    const onScroll = () => setVisible(window.scrollY > 260);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <nav
      aria-label="Quick customer actions"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-brand-border bg-white/95 backdrop-blur-md shadow-[0_-4px_16px_-4px_rgba(0,0,0,0.12)] md:hidden"
      data-testid="mobile-action-bar"
    >
      <div className="grid grid-cols-3 gap-1 p-2">
        <Link
          to={businessDetails.customerAppUrl}
          onClick={() => track("customer_app_clicked", { location: "mobile-bar" })}
          className="flex min-h-[52px] flex-col items-center justify-center gap-0.5 rounded-xl bg-brand-teal text-xs font-semibold text-white"
          data-testid="bar-app"
          aria-label="Open Customer App"
        >
          <Smartphone className="h-5 w-5" aria-hidden="true" /> App
        </Link>
        <a
          {...ext}
          href={businessDetails.digitalPostboxUrl}
          onClick={() => track("digital_postbox_clicked", { location: "mobile-bar" })}
          className="flex min-h-[52px] flex-col items-center justify-center gap-0.5 rounded-xl border border-brand-navy text-xs font-semibold text-brand-navy"
          data-testid="bar-postbox"
          aria-label="Open Digital Postbox — opens external customer service in a new tab"
        >
          <MailCheck className="h-5 w-5" aria-hidden="true" /> Postbox
        </a>
        <a
          href={businessDetails.phoneLink}
          onClick={() => track("phone_number_clicked", { location: "mobile-bar" })}
          className="flex min-h-[52px] flex-col items-center justify-center gap-0.5 rounded-xl border border-brand-border bg-brand-bg text-xs font-semibold text-brand-navy"
          data-testid="bar-call"
        >
          <Phone className="h-5 w-5 text-brand-teal" aria-hidden="true" /> Call
        </a>
      </div>
    </nav>
  );
};
